export default {"src":"/_next/static/media/Italy.52fc9979.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};